import UserAvatarGroup from '@rossum/components/user-avatar/UserAvatarGroup';
import { Stack } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { DocumentModifier } from '../../document-list-base/helpers/resolveModifierFromUrl';

export const RenderAssignees = ({
  value,
}: GridRenderCellParams<Record<never, never>, DocumentModifier[]>) => {
  const users = value?.flatMap(modifier =>
    typeof modifier !== 'string' ? [modifier] : []
  );

  if (!users || users.length === 0) return null;

  return (
    <Stack mt={1}>
      <UserAvatarGroup users={users} />
    </Stack>
  );
};
